import { render, staticRenderFns } from "./veSbzcZcAllocate.vue?vue&type=template&id=4534b456&scoped=true"
import script from "./veSbzcZcAllocate.vue?vue&type=script&lang=js"
export * from "./veSbzcZcAllocate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4534b456",
  null
  
)

export default component.exports